import { render } from "./AgGrid.vue?vue&type=template&id=3a2b08bc"
import script from "./AgGrid.vue?vue&type=script&lang=js"
export * from "./AgGrid.vue?vue&type=script&lang=js"

import "./AgGrid.vue?vue&type=style&index=0&id=3a2b08bc&lang=css"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3a2b08bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a2b08bc', script)) {
    api.reload('3a2b08bc', script)
  }
  
  module.hot.accept("./AgGrid.vue?vue&type=template&id=3a2b08bc", () => {
    api.rerender('3a2b08bc', render)
  })

}

script.__file = "src/components/AgGrid.vue"

export default script